import { Fragment, h } from 'preact';
import { useState, useEffect, useRef, useCallback } from 'preact/hooks';
import { INTERNAL_EVENTS, SDK_EVENTS, DATA_EVENTS, EVENTS } from '../../../constants/events.cnst';
import './search.scss';
import { ArticleSuggestion } from '../suggestions/article/article';
import { FAQSuggestion } from '../suggestions/faq/faq';
import { SnippetSuggestion } from '../suggestions/snippet/snippet';
import { FileSuggestion } from '../suggestions/file/file';
import { getHTML } from '../../../templatemanager/base/domManager';
import { ClassMapConstanst, IdMapConstant, ProjConstants } from '../../../constants/projConsts';
import { SuggestionPlaceholder } from '../suggestion-placeholder/suggestion-placeholder';
import { HandleViewMoreLessButtons } from '../atom/actionButtons';
import { DialogSuggestion } from '../suggestions/dialog/dialog'; 
import  RandomuuidPipe from '../../../utils/randomuuid';
import { FeebackConst } from '../../../constants/settingsConsts';
import { useDebounce } from '../../../../../hooks/debounce';
import searchEmptyIcon from '../../../../../assets/images/icons/search-empty.png';
import { AgenticSearchResultsHTML } from '../suggestions/agentic-results/agentic-results';




export function searchInputTemplate(props:any) {
    return <div className="input-block aa-input-block">
        <textarea
            id="aa-search-input"
            className="input-control auto-expand-textarea"
            aria-describedby="search"
            placeholder={props?.hostInstance.rootService.placeholderTextSearch}
            rows={1}
        // onKeyUp={(e) => (e.key === 'Enter' && getSearchResults(e)) || (e.key !== 'Enter' && onSearch(e))}
        />
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="aa-input-search-icon">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.33342 1.66675C4.65152 1.66675 1.66675 4.65152 1.66675 8.33342C1.66675 12.0153 4.65152 15.0001 8.33342 15.0001C9.87401 15.0001 11.2925 14.4775 12.4215 13.6L16.9108 18.0893C17.2363 18.4148 17.7639 18.4148 18.0893 18.0893C18.4148 17.7639 18.4148 17.2363 18.0893 16.9108L13.6 12.4215C14.4775 11.2925 15.0001 9.87401 15.0001 8.33342C15.0001 4.65152 12.0153 1.66675 8.33342 1.66675ZM3.33341 8.33342C3.33341 5.57199 5.57199 3.33341 8.33342 3.33341C11.0948 3.33341 13.3334 5.57199 13.3334 8.33342C13.3334 11.0948 11.0948 13.3334 8.33342 13.3334C5.57199 13.3334 3.33341 11.0948 3.33341 8.33342Z"
                fill="#667085"
            />
        </svg>

        <button className="clear-search aa-input-search-close aa-hidden">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 5.2002L5 15.2002M5 5.2002L15 15.2002" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>
}



export function Search({ hostInstance }: any) {

    
    const languageData = hostInstance?.languagedata
    hostInstance.rootService.placeholderTextSearch = languageData?.ASK_A_QUESTION
    interface SearchResponse {
        faqs?: { question: string; answer: string[] }[];
        articles?: { title: string; content: string }[];
        files?: { title: string; content: string }[];
        snippets?: { snippet: string }[];
        dialogs?: { dialog: string }[];
        totalSearchResults?: number;
    }

    const [searchText, setSearchText]: any = useState({ value: '', isEntered: false, stTime : null, edTime : null });
    const [autocompleteText, setAutocompleteText] = useState('');
    // const [rootServiceInstance.answerPlaceableIDs, setAnswerPlaceableIDs] = useState<AnswerPlaceableID[]>([]);
    const [searchResponse, setSearchResponse] = useState<SearchResponse>({});
    const [agenticSearchResponse, setAgenticSearchResponse] = useState<any>({});
    const [searched, setSearched] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [menuResponse, setMenuResponse] = useState<any>([]);
    const rootServiceInstance = hostInstance.rootService;


    const classConstants : any = ClassMapConstanst;
    const idConstants : any = IdMapConstant;

    let startTime : any = null;
    let endTime : any = null;


    useEffect(() => {
        const handleAgentAssistAgentResponse = (agentResponse : any) => {
            if (agentResponse?.suggestions && Object.keys(agentResponse?.suggestions)?.length > 0 && (agentResponse.isSearch || agentResponse.uiunqref)) {
                handleSearchResponse(agentResponse);
                setShowSpinner(false);
                rootServiceInstance.searchedResultData = agentResponse;
            }
        }
        const handleMenuResponse = (menuResponse : any) => {
           
            if(menuResponse?.usecases?.length > 0){
                hostInstance.rootService.menuResponseArr = menuResponse?.usecases;
                menuResponse?.usecases?.forEach((suggestion : any, index : number) => {
                    suggestion.intentName = suggestion.usecaseName;
                    suggestion.positionId = RandomuuidPipe('positionId');
                    suggestion.sourceMsgId = 'fromLibrary';
                    suggestion.suggestionFrom = ProjConstants.MYBOT;
                })
                hostInstance.emit(INTERNAL_EVENTS.CUSTOM_TAB_DIALOG_WORKFLOW, menuResponse?.usecases);
                setMenuResponse(menuResponse.usecases);
            }
        }

        hostInstance.on('AGENT_AI_AGENT_RESPONSE', handleAgentAssistAgentResponse);
        hostInstance.on('AGENT_AI_MENU_RESPONSE', handleMenuResponse);
        hostInstance.on(DATA_EVENTS.AGENTIC_RESPONSE, handleAgenticResponse);
        addSearchBlock();
        return () => {
            hostInstance.off('AGENT_AI_AGENT_RESPONSE', handleAgentAssistAgentResponse);
            hostInstance.off('AGENT_AI_MENU_RESPONSE', handleMenuResponse);
            hostInstance.off(DATA_EVENTS.AGENTIC_RESPONSE, handleAgenticResponse);
        };
    }, []);


    useEffect(() => {
        if(!hostInstance?.rootService?.isAgenticCoPilotEnabled){
            rootServiceInstance.handleSearchText(searchText, hostInstance);
        }
        else{
            if(searchText?.isEntered){
                hostInstance?.socketConnection?.emitEvents(EVENTS.agentic_request, {
                    isSearch:true,
                    override:false,
                    query : searchText?.value,
                    intType: "myBot",
                    phraseInput: searchText?.value,
                    retrySearch: false,
                    botId: hostInstance?.config?.connectionDetails?.botId
                })
            }
        }
    }, [searchText]);

    useEffect(() => {
        if(agenticSearchResponse && Object.keys(agenticSearchResponse)?.length > 0){
            setAgenticSearchResults(agenticSearchResponse);
            setShowSpinner(false);
        }
    }, [agenticSearchResponse]);

    useEffect(() => {
        enableOrdisableInputCloseIcon(showSpinner);
    }, [showSpinner]);

    useEffect(() => {
        if(menuResponse?.length > 0){
            const menuSearchEle = hostInstance?.chatEle?.querySelector(classConstants.SEARCH_MENU_WRAPPER) as HTMLElement
            if(menuSearchEle.hasChildNodes()){
                menuSearchEle.replaceChildren()
            }
            let menuHTML : any = getHTML(DialogSuggestion, { hostInstance: hostInstance, searchedText: searchText?.value, type : 'menu', suggestions : menuResponse}, hostInstance);
            if(menuHTML){
                rootServiceInstance.checkTransferDetailsAndDisableWidget(hostInstance);
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, menuHTML, { event: SDK_EVENTS.MENU_TEMPLATE, data: menuResponse });
                menuSearchEle?.append(menuHTML);
                rootServiceInstance.handleDialogClickEvents(menuHTML, menuResponse, hostInstance);
            }
        }
    }, [menuResponse]);


    useEffect(() => {
        let inputSearchIcon = hostInstance?.chatEle?.querySelector(classConstants.SEARCH_INPUT_ICON);
        inputSearchIcon.classList.remove(classConstants.DISABLED);
        if(!rootServiceInstance.faqAnswerIdsPlace && searchResponse && Object.keys(searchResponse)?.length > 0){            
            setSuggestions();
            checkFaqAnswerNotRenderCountAndRequest();
        }
    }, [searchResponse])

    const enableOrdisableInputCloseIcon= (spinner : boolean) => {
        let inputEle = hostInstance?.chatEle?.querySelector(classConstants.SEARCH_INPUT_BLOCK);
        if(inputEle){
            let closeIcon = inputEle?.querySelector(classConstants.SEARCH_INPUT_CLOSE);
            closeIcon.disabled = spinner;
        }
    }

    const autoExpandTextarea = (textarea: HTMLTextAreaElement) => {
        textarea.style.height = 'auto';
        textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
    };

    const addSearchBlock =() => {
        let inputHtml = getHTML(searchInputTemplate, {}, hostInstance);
        
        if(inputHtml){

            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, inputHtml, { event: SDK_EVENTS.SEARCH_INPUT});

            hostInstance?.chatEle?.querySelector(classConstants.SEARCH_SUGGESTION_WRAPPER)?.querySelector(`#${idConstants.SEARCH_SUGGESTION_BLOCK}`)?.append(inputHtml);

            const textareaElement = (inputHtml as HTMLElement).querySelector(`#${idConstants.SEARCH_INPUT}`) as HTMLTextAreaElement;

            hostInstance.eventManager?.addEventListener(`#${idConstants.SEARCH_INPUT}`, 'input', (e : any) => {
                autoExpandTextarea(e.target);
            }, inputHtml);

            hostInstance.eventManager?.addEventListener(`#${idConstants.SEARCH_INPUT}`, 'keyup', (e : any) => {
                if(e.key === 'Enter'){
                    e.preventDefault();
                    const sanitizedValue = hostInstance.rootService.sanitizeHTML(e.target.value);
                    
                    if(sanitizedValue){
                        getSearchResults(sanitizedValue);
                    }
                }else {
                    onSearch(e);
                    searchDynamicDialogTasks(e)
                }
            }, inputHtml);

            hostInstance.eventManager?.addEventListener(`#${idConstants.SEARCH_INPUT}`, 'keydown', (e : any) => {
                if(e.key === 'Enter'){
                    e.preventDefault();
                }
            }, inputHtml);

            hostInstance.eventManager?.addEventListener(classConstants.SEARCH_INPUT_CLOSE, 'click', (e : any) => {
                clearSearch();
                if(textareaElement) {
                    textareaElement.style.height = 'auto';
                }
            }, inputHtml);

            hostInstance.eventManager?.addEventListener(classConstants.SEARCH_INPUT_ICON, 'click', (e : any) => {
                let inputEle = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_INPUT}`);
                const sanitizedValue = hostInstance.rootService.sanitizeHTML(inputEle.value);
                if(sanitizedValue){
                    getSearchResults(sanitizedValue);
                }
            }, inputHtml);
        }
    }

    const onSearch = (event: any) => {
        setSearchText({ value: event.target.value, isEntered: false });
        let searchText = event.target.value;
        // if (rootService.settingsData?.searchAssistConfig?.showAutoSuggestions) {
        if (searchText.length > 0) {
            if (autocompleteText === searchText || autocompleteText.includes(searchText)) {
                // setSecondaryIp(true);
            } else {
                // setSecondaryIp(false);
            }
        } else {
            // setSecondaryIp(true);
            clearSearch();
        }

        if (searchText?.length > 0 && !startTime) {
            startTime = new Date();
        }
    };

    const handleAgenticResponse = (response : any) => {
        if(response && response?.isSearch){
            setSearched(true);
            setAgenticSearchResponse(response);
        }
    }

    const getSearchResults = (value: any) => {
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.SEARCH_EVENT, data: {value : value} });
        setShowSpinner(true);
        setValue(value, true);
        setAutocompleteText('');
        setTimeout(() => {
          setShowSpinner(false);
        }, 15000);
    };

    const searchDynamicDialogTasksImmediate = (event: any) => {
        const targetValue = event.target.value.trim();
        if (targetValue.length > 0) {
            const filteredItems = hostInstance?.rootService?.checkDynamicTasksAndFilter(hostInstance, targetValue);
            setMenuResponse([...menuResponse, ...filteredItems]);
        } else {
            setMenuResponse([...hostInstance?.rootService?.menuResponseArr]);
        }
    };
    
    const searchDynamicDialogTasks = useDebounce(searchDynamicDialogTasksImmediate, 300);

    const setValue = (value: string, isEntered = false) => {
        let stTime = null;
        let edTime = null;
        if(isEntered){
            stTime = startTime;
            edTime = new Date();
        }
        setSearchText({ value, isEntered, stTime, edTime });
    }

    const clearSearch = () => {
        setSearchText({ value: '', isEntered: false });
        setAutocompleteText('');
        setSearched(false);
        setSearchResponse({});
        setAgenticSearchResponse({});
        startTime = null;
        rootServiceInstance.faqAnswerIdsPlace = false;
        setMenuResponse([...menuResponse,...hostInstance?.rootService?.menuResponseArr]);
        
        // Reset textarea height
        const textareaElement = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_INPUT}`) as HTMLTextAreaElement;
        if(textareaElement) {
            textareaElement.value = '';
            textareaElement.style.height = 'auto';
        }
    };

    const handleSearchResponse = (response: any) => {
        setSearched(true);
        if (response?.suggestions) {
            if (!response.uiunqref) {
                rootServiceInstance.faqAnswerIdsPlace = false;
                
                let sResponse = (rootServiceInstance.formatSearchResponse(response, true, 0));

                if (sResponse && Object.keys(sResponse).length > 0) {
                    sResponse = {
                        ...sResponse, totalSearchResults: (sResponse.dialogs?.length || 0) +
                            (sResponse.faqs?.length || 0) +
                            (sResponse.articles?.length || 0) +
                            (sResponse.files?.length || 0) +
                            (sResponse.snippets?.length || 0)
                    }
                    setSearchResponse(sResponse);
                }
            } else if(response.uiunqref){
                let ambiguityTokenExt : any = JSON.parse(atob(response.uiunqref));
                response.suggestions.faqs = rootServiceInstance.formatFAQResponse(response.suggestions.faqs);
                rootServiceInstance.faqAnswerIdsPlace = ambiguityTokenExt && ambiguityTokenExt?.question === response.suggestions.faqs[0].question ? true : false;                
                if (rootServiceInstance.faqAnswerIdsPlace) {
                    const faqWithoutAnswerIndex = response?.suggestions?.faqs?.findIndex((faq : any, index : number) => {
                        if (faq.question === ambiguityTokenExt.question) {
                            return faq;
                        }
                    });
                    let faqWithoutAnswer : any = {};
                    if(faqWithoutAnswerIndex >= 0){
                        faqWithoutAnswer = response?.suggestions?.faqs[faqWithoutAnswerIndex];                        
                    }
                    if(faqWithoutAnswer && Object.keys(faqWithoutAnswer)?.length > 0){
                        let existingFaqs : any = [];
                        setSearchResponse((prevResponse: any) => {
                            existingFaqs = prevResponse?.faqs?.map((faq: any, idx : number) => {
                                if (faqWithoutAnswer && faqWithoutAnswer.answer && idx === ambiguityTokenExt.index) {
                                    faq.answer = faqWithoutAnswer.answer;
                                }
                                if (faqWithoutAnswer) {
                                    faq.showSpinner = false;
                                }
                                return faq;
                            })
                            return prevResponse;
                        });                        
                        rootServiceInstance.handleFaqAmbiguityDescElement(idConstants.SEARCH_FAQ_SUGGESTION, ambiguityTokenExt, existingFaqs, hostInstance);
                        setSearchResponse((prevResponse: any) => ({
                            ...prevResponse,
                            faqs: existingFaqs
                        }));
                    }     
                }
            }
        } else {
            setSearchResponse({});
        }
    };

    const setAgenticSearchResults = (response : any) => {
        let agenticSearchResultsElement = hostInstance?.chatEle?.querySelector(`#${idConstants.AGENTIC_SEARCH_RESULTS}`);
        if(agenticSearchResultsElement && Object.keys(response)?.length > 0){
            removeSuggestionFromDom([agenticSearchResultsElement]);
            let agenticSearchResultsHtml = getHTML(AgenticSearchResultsHTML, { searchResponse: response, hostInstance: hostInstance }, hostInstance);
            agenticSearchResultsElement?.append(agenticSearchResultsHtml);

            if(agenticSearchResultsHtml){
                hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, agenticSearchResultsHtml, { event: SDK_EVENTS.AGENTIC_SEARCH_RESULTS_TEMPLATE, data: response });
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(agenticSearchResultsElement, '.aa-agentic-search-results-title', ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
                rootServiceInstance.handleSendCopyForAgenticSearchResults(agenticSearchResultsElement, response, hostInstance);
            }
        }
        
    }

    const removeSuggestionFromDom = (suggestionslist: any) => {
        suggestionslist?.forEach((element: any) => {
            if (element) {
                element.innerHTML = '';
            }
        });
    }

    const setSuggestions = () => {
        let faqSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_FAQ_SUGGESTION}`);
        let snippetSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_SNIPPET_SUGGESTION}`);
        let articleSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_ARTICLE_SUGGESTION}`);
        let fileSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_FILE_SUGGESTION}`);
        let dialogSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.SEARCH_DIALOG_SUGGESTION}`);
        let agenticSearchResultsElement = hostInstance?.chatEle?.querySelector(`#${idConstants.AGENTIC_SEARCH_RESULTS}`);

        
        removeSuggestionFromDom([faqSuggestionElement, snippetSuggestionElement, articleSuggestionElement, fileSuggestionElement, dialogSuggestionElement, agenticSearchResultsElement]);

        if (searchResponse?.dialogs?.length) {
            let dialogHtml: any;
            dialogHtml = getHTML(DialogSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, suggestions: searchResponse.dialogs, suggestionIndex : 0, type : 'search'}, hostInstance);
            rootServiceInstance.checkTransferDetailsAndDisableWidget(hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, dialogHtml, { event: SDK_EVENTS.SEARCH_DIALOG_TEMPLATE, data: searchResponse.dialogs });
            dialogSuggestionElement?.append(dialogHtml);
            rootServiceInstance.handleDialogClickEvents(dialogHtml, searchResponse?.dialogs, hostInstance);
        }

        if ((searchResponse?.faqs || [])?.length) {
            let faqHtml: any;
            let faqMoreLessActionHtml: any;
            faqHtml = getHTML(FAQSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, faqs: searchResponse.faqs, viewCount: 2 }, hostInstance);
            faqMoreLessActionHtml = getHTML(HandleViewMoreLessButtons, { hostInstance: hostInstance, faqs: searchResponse.faqs, moreClick: false, suggestionLength :  searchResponse.faqs?.length, showLessText : 'Show less FAQs', showMoreText : 'Show more FAQs' }, hostInstance);
            if (faqMoreLessActionHtml) {
                faqHtml?.append(faqMoreLessActionHtml);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, faqHtml, { event: SDK_EVENTS.SEARCH_FAQ_TEMPLATE, data: searchResponse.faqs });
            faqSuggestionElement?.append(faqHtml);

            if(faqHtml){
                rootServiceInstance.handleSeeMoreButtonsForFaq(faqSuggestionElement, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
            }

            let faqListHTML = faqHtml.querySelectorAll(classConstants.SUGGESTION_EACH);

            rootServiceInstance.renderEachFaqInSuggestionList(searchResponse, faqListHTML, hostInstance, false, {});

            //more and less article button click events handling
            if (faqMoreLessActionHtml) {
                rootServiceInstance.handleSuggestionMoreClickEvent(faqMoreLessActionHtml, faqSuggestionElement, faqListHTML, hostInstance);
                rootServiceInstance.handleSuggestionLessClickEvent(faqMoreLessActionHtml, faqSuggestionElement, faqListHTML, hostInstance);
            }
            rootServiceInstance.renderFeedbackForEachSuggestion(faqListHTML, searchResponse.faqs, FeebackConst.FAQS, hostInstance);

        }

        if (searchResponse?.snippets?.length) {
            let snippetHtml: any;
            snippetHtml = getHTML(SnippetSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, snippets: searchResponse.snippets, suggestionIndex : 0 }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, snippetHtml, { event: SDK_EVENTS.SEARCH_SNIPPET_TEMPLATE, data: searchResponse.snippets });
            snippetSuggestionElement?.append(snippetHtml);

            if(snippetHtml){
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(snippetSuggestionElement, ClassMapConstanst.DESC_TEXT_SNIPPET_EXTERNAL, ClassMapConstanst.EXTERNAL_SNIPPET_MORE_BTN_CONTAINER, hostInstance);
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(snippetSuggestionElement, ClassMapConstanst.DESC_TEXT_SNIPPET_INTERNAL, ClassMapConstanst.INTERNAL_SNIPPET_MORE_BTN_CONTAINER, hostInstance);
            }
            // send, copy and link buttons of article click events handling.
            let snippetListHtml = snippetHtml.querySelectorAll(classConstants.SUGGESTION_EACH);
            rootServiceInstance.renderEachSnippetInSuggestionList(searchResponse, snippetListHtml, hostInstance);
            rootServiceInstance.renderFeedbackForEachSuggestion(snippetListHtml, searchResponse.snippets, FeebackConst.ANSWERS, hostInstance);

        }

        if ((searchResponse?.articles || [])?.length > 0) {
            let articleHtml: any;
            let articleMoreLessActionHtml: any;
            articleHtml = getHTML(ArticleSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, articles: searchResponse.articles, viewCount: 2 }, hostInstance);
            articleMoreLessActionHtml = getHTML(HandleViewMoreLessButtons, { hostInstance: hostInstance, articles: searchResponse.articles, moreClick: false, suggestionLength :  searchResponse.articles?.length, showLessText : 'Show less web pages', showMoreText : 'Show more web pages' }, hostInstance);
            if (articleMoreLessActionHtml) {
                articleHtml?.append(articleMoreLessActionHtml);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, articleHtml, { event: SDK_EVENTS.SEARCH_ARTICE_TEMPLATE, data: searchResponse.articles });
            articleSuggestionElement?.append(articleHtml);

            if(articleHtml){
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(articleSuggestionElement, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
            }
            // send, copy and link buttons of article click events handling.
            let articlesListHTML = articleHtml.querySelectorAll(classConstants.SUGGESTION_EACH);
            rootServiceInstance.renderEachArticleInSuggestionList(searchResponse, articlesListHTML, hostInstance);

            //more and less article button click events handling
            if (articleMoreLessActionHtml) {
                rootServiceInstance.handleSuggestionMoreClickEvent(articleMoreLessActionHtml, articleSuggestionElement, articlesListHTML, hostInstance);
                rootServiceInstance.handleSuggestionLessClickEvent(articleMoreLessActionHtml, articleSuggestionElement, articlesListHTML, hostInstance);
            }
            rootServiceInstance.renderFeedbackForEachSuggestion(articlesListHTML, searchResponse.articles, FeebackConst.ANSWERS, hostInstance);

        }

        if (searchResponse?.files?.length) {
            let fileHtml: any;
            let fileMoreLessActionHtml: any;
            fileHtml = getHTML(FileSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, files: searchResponse.files }, hostInstance);
            fileMoreLessActionHtml = getHTML(HandleViewMoreLessButtons, { hostInstance: hostInstance, files: searchResponse.files, moreClick: false, suggestionLength :  searchResponse.files?.length, showLessText : 'Show Less Files', showMoreText : 'Show More Files' }, hostInstance);
            if (fileMoreLessActionHtml) {
                fileHtml?.append(fileMoreLessActionHtml);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, fileHtml, { event: SDK_EVENTS.SEARCH_FILE_TEMPLATE, data: searchResponse.files });
            fileSuggestionElement?.append(fileHtml);

            if(fileHtml){
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(fileSuggestionElement, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
            }
            // send, copy and link buttons of article click events handling.
            let filesListHtml = fileHtml.querySelectorAll(classConstants.SUGGESTION_EACH);
            rootServiceInstance.renderEachFileInSuggestionList(searchResponse, filesListHtml, hostInstance);
            //more and less article button click events handling
            if (fileMoreLessActionHtml) {
                rootServiceInstance.handleSuggestionMoreClickEvent(fileMoreLessActionHtml, fileSuggestionElement, filesListHtml, hostInstance);
                rootServiceInstance.handleSuggestionLessClickEvent(fileMoreLessActionHtml, fileSuggestionElement, filesListHtml, hostInstance);
            }
            rootServiceInstance.renderFeedbackForEachSuggestion(filesListHtml, searchResponse.files, FeebackConst.ANSWERS, hostInstance);
        }
    }
  
    const checkFaqAnswerNotRenderCountAndRequest = () => {
        const answerNotRenderedElements : any = searchResponse.faqs?.filter((faq: any, index : any) => {
            if(!faq.answer){
                faq.index = index;
                return true;
            }
            return false;
        });
        if (answerNotRenderedElements?.length === 1) {
            getFaqAnswerAndToggle(answerNotRenderedElements[0], answerNotRenderedElements[0]?.index);
        }
    };

    const getFaqAnswerAndToggle = (faq: any, index : any) => {
        faq.toggle = !faq.toggle;
        faq.seeMoreWrapper = false;
        let faqId = idConstants.SEARCH_FAQ_SUGGESTION;
        rootServiceInstance.toggleArrows(index, faqId, hostInstance);
        rootServiceInstance.checkAnswerAndToggleForSearch(faq, index, hostInstance);

    };

    return (
        <div className="search-block-data-suggestions-wrapper aa-search-suggestion-wrapper">
            <div class="search-block-data-suggestions">
                <div className="suggestionslist-conntent-search">
                    {(Object.keys(searchResponse)?.length > 0 || searched) && <Fragment>
                        <div className="suggestionslist-conntent-scroll">
                            <SuggestionPlaceholder hostInstance={hostInstance} searchResponse={searchResponse} isAssist ={false} agenticSearchResponse={agenticSearchResponse}/>
                        </div>
                    </Fragment>
                    }
                    {(Object.keys(searchResponse)?.length == 0 && Object.keys(agenticSearchResponse)?.length == 0 && searched && !showSpinner) &&
                        <div class="empty-search-container-wrapper">
                            <figure>
                                <img src={searchEmptyIcon} alt="No search results"/>
                            </figure>
                            <h1 className="aa-text-md m-0 center">{languageData?.NO_SEARCH_RESULT}</h1>
                            <p className="aa-desc-sm m-0 center">{languageData?.REPHRASE_QUESTION}</p>
                        </div>
                    }
                    
                    {(Object.keys(searchResponse)?.length == 0 && Object.keys(agenticSearchResponse)?.length == 0 && !searched && !showSpinner && menuResponse?.length === 0) &&
                        <div class="empty-search-container-wrapper">
                            <figure>
                                <img src={searchEmptyIcon} alt="Search" />
                            </figure>
                            <p className="aa-desc-sm m-0 center">{languageData?.TAP_SEARCH}</p>
                        </div>
                    }

                    <div className={`search-app-dialog-content ${!searched && menuResponse?.length > 0 ? '' : 'aa-hidden'}`}>
                        <div className="search-header-content">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.841952 11.0001C0.841952 8.62216 2.72765 6.66675 5.08757 6.66675C7.44748 6.66675 9.33318 8.62216 9.33318 11.0001C9.33318 13.378 7.44748 15.3334 5.08757 15.3334C4.60247 15.3334 4.13515 15.2501 3.69948 15.0963C3.62748 15.0709 3.58281 15.0552 3.55005 15.0444C3.54411 15.0424 3.53925 15.0408 3.53535 15.0396L3.53173 15.04C3.50886 15.0425 3.4777 15.0467 3.41992 15.0546L1.42339 15.3273C1.20735 15.3568 0.990542 15.2788 0.842822 15.1184C0.695102 14.958 0.635145 14.7355 0.682271 14.5227L1.08983 12.6815C1.104 12.6176 1.11157 12.583 1.11644 12.5576C1.11672 12.5562 1.1172 12.5536 1.1172 12.5536C1.11599 12.5494 1.11445 12.5442 1.11254 12.5378C1.10156 12.5015 1.08541 12.4519 1.05917 12.3716C0.918046 11.9396 0.841952 11.4782 0.841952 11.0001Z" fill="#155EEF" />
                                <path d="M3.43153 5.58181C3.94992 5.42055 4.50247 5.33341 5.07842 5.33341C8.22071 5.33341 10.6666 7.9272 10.6666 11.0001C10.6666 11.5425 10.5904 12.07 10.4476 12.571C10.8089 12.506 11.1594 12.4091 11.4957 12.2831C11.5431 12.2654 11.5905 12.2472 11.6384 12.2308C11.6771 12.2353 11.7156 12.2413 11.7542 12.247L13.8961 12.561C13.9972 12.5758 14.112 12.5927 14.212 12.5984C14.3227 12.6047 14.4949 12.604 14.6773 12.5255C14.9051 12.4276 15.0884 12.2485 15.1916 12.023C15.2742 11.8424 15.2788 11.6703 15.2751 11.5595C15.2717 11.4593 15.2575 11.3442 15.245 11.2428L14.9743 9.04417C14.9673 8.98701 14.9636 8.95699 14.9615 8.93498C14.9732 8.88682 14.9952 8.84022 15.0129 8.79403C15.2654 8.13202 15.4034 7.41465 15.4034 6.66675C15.4034 3.34892 12.6972 0.666748 9.36827 0.666748C6.41108 0.666748 3.94537 2.7833 3.43153 5.58181Z" fill="#155EEF" />
                            </svg>
                            <h1 className="aa-text-sm semibold m-0">{languageData?.ALL_DIALOG}</h1>
                        </div>
                        <div className="search-all-dialog-content aa-search-menu-wrapper">
                            {/* component for app dialog */}
        

                        </div>
                    </div>
                    
                </div>
                 <div className="search-block-input" id="searchSuggestionsBlock">
                </div>
            </div>
            {showSpinner &&
                <div id="loader" className="loader-progress-individual">
                    <div className="loading-border"></div>
                </div>
            }
        </div>
    );
};

export default Search;
